export default {"src":"/_next/static/media/quiz-start.66d52ac3.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};